import { render, staticRenderFns } from "./TransactionViewComponent.vue?vue&type=template&id=0d29f532"
import script from "./TransactionViewComponent.js?vue&type=script&lang=js&external"
export * from "./TransactionViewComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports